import React from 'react';
import { Route, Switch } from 'react-router-dom';
import MLServiceApi from './MLServiceApi';
import MLServiceWeb from './MLServiceWeb';

const Routes = () => (
  <Switch>
    <Route path="/ml/api" component={MLServiceApi} />
    <Route path="/ml/web" component={MLServiceWeb} />
  </Switch>
);

export default Routes;
